import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { clearUser } from "../redux/users/usersSlice";
import { isSuperAdmin } from "../utils/accountType";
import classes from "./Header.module.css";

const getInitials = (name) => {
	if (!name) return "TT";
	const parts = String(name).trim().split(/\s+/).filter(Boolean);
	if (!parts.length) return "TT";
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const Header = ({ onMenuClick }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const menuRef = useRef(null);

	const user = useSelector((state) => state?.user?.user);
	const username = user?.username || localStorage.getItem("username") || "User";
	const roleLabel = isSuperAdmin(user) ? "Super Admin" : "Organization Admin";
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setIsMenuOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	const handleSignOut = () => {
		setIsMenuOpen(false);
		dispatch(clearUser());
		localStorage.clear();
		navigate("/login", { replace: true });
	};

	return (
		<header className={classes.header}>
			<button aria-label="Open navigation" className={classes.menuButton} onClick={onMenuClick} type="button">
				<svg fill="none" height="20" viewBox="0 0 24 24" width="20">
					<path d="M4 7h16M4 12h16M4 17h16" stroke="#0B1F2A" strokeLinecap="round" strokeWidth="2" />
				</svg>
			</button>

			<div className={classes.actions}>
				<button aria-label="Notifications" className={classes.bell} type="button">
					<svg fill="none" height="18" viewBox="0 0 24 24" width="18">
						<path
							d="M12 22a2.2 2.2 0 0 0 2.2-2h-4.4A2.2 2.2 0 0 0 12 22Zm6.5-5.5V11a6.5 6.5 0 1 0-13 0v5.5L4 18v1h16v-1l-1.5-1.5Z"
							fill="#5B6B7A"
						/>
					</svg>
					<span className={classes.badge} />
				</button>

				<span className={classes.divider} aria-hidden="true" />

				<div className={classes.profileMenu} ref={menuRef}>
					<button
						aria-expanded={isMenuOpen}
						aria-haspopup="menu"
						className={classes.profileButton}
						onClick={() => setIsMenuOpen((open) => !open)}
						type="button">
						<div className={classes.avatar}>{getInitials(username)}</div>
						<div className={classes.meta}>
							<span className={classes.name}>{username}</span>
							<span className={classes.role}>{roleLabel}</span>
						</div>
						<svg aria-hidden="true" className={classes.chevron} fill="none" height="16" viewBox="0 0 16 16" width="16">
							<path
								d="M4 6l4 4 4-4"
								stroke="#5B6B7A"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="1.5"
							/>
						</svg>
					</button>

					{isMenuOpen ? (
						<div className={classes.dropdown} role="menu">
							<button
								className={classes.dropdownItem}
								onClick={() => {
									setIsMenuOpen(false);
									navigate("/change-password");
								}}
								role="menuitem"
								type="button">
								Change Password
							</button>
							<button className={classes.dropdownItem} onClick={handleSignOut} role="menuitem" type="button">
								Sign Out
							</button>
						</div>
					) : null}
				</div>
			</div>
		</header>
	);
};

export default Header;
